import type { PartialStoreState } from '../typings'

export const selectDomain = (state: PartialStoreState) => state.domain.publicData.domain
export const selectDomainRevision = (state: PartialStoreState) =>
  state.domain.publicData.domain.domainRevision
